// Mirrors Domain/Common/LevelCalculator: quadratic XP curve, capped at level 100.
export function levelProgress(level, experience) {
  const current = Math.min(100, Math.max(1, Number(level) || 1));
  const xp = Number(experience) || 0;
  const lower = current <= 1 ? 0 : 50 * current * current;
  const upper = current >= 100 ? lower : 50 * (current + 1) * (current + 1);
  const percent = current >= 100 ? 100 : Math.max(0, Math.min(100, ((xp - lower) / (upper - lower)) * 100));
  const remaining = current >= 100 ? 0 : Math.max(0, upper - xp);
  return { current, lower, upper, remaining, percent };
}

export const RENOWN_STAGES = [
  { min: 0, name: 'Gründung', detail: 'Holzrahmen & Laternen' },
  { min: 1000, name: 'Anerkannt', detail: 'Bronzeverzierungen' },
  { min: 5000, name: 'Angesehen', detail: 'Steinbögen & Bronzebeschläge' },
  { min: 15000, name: 'Berühmt', detail: 'Gold & farbiges Glas' },
  { min: 50000, name: 'Legendär', detail: 'Leuchtende Runen' },
];
export const renownStage = value => RENOWN_STAGES.reduce((found, stage, index) => value >= stage.min ? index : found, 0);
